<template>
  <v-alert v-if="template && template.instructions"
           type="info"
           tile>
    <div class="font-weight-bold text-uppercase">
      Template Instructions
    </div>
    <div>
      {{ template.instructions }}
    </div>
  </v-alert>
</template>
<script>
export default {
  props: {
    template: {
      type: Object,
      required: false,
    }
  }
}
</script>
